<template>
  <div>
    <div class="page">
      <div class="page-bg user-header">
        <div class="user-info">
          <template v-if="isLogin">
            <div class="img" @click="goPage('/user/profile')">
              <img
                :src="userInfo.avatar ? userInfo.avatar : require('@/assets/images/user/my/default-head.png')"
              alt="" />
            </div>
            <div class="info" @click="goPage('/user/profile')">
              <div class="name">
                {{userInfo.nickname}}
              </div>
              <div class="phone">ID: {{ userInfo.auid }}</div>
            </div>
          </template>

          <template v-else>
            <div class="img">
              <img
                :src="
                  require('@/assets/images/user/my/default-head.png')
                "
                alt=""
              />
            </div>
            <div class="info" @click="$router.push('/login')">
              <div class="name">登录</div>
            </div>
          </template>
        </div>
        <div class="user-nav">
          <div class="item" @click="goPage('/user/order')">
            <span
              class="icon"
              style="background-size: auto 0.5rem"
              :style="{
                'background-image': `url(${require('@/assets/images/user/my/1.png')})`,
              }"
            ></span>
            <div class="text">我的订单</div>
          </div>
          <div class="item" @click="exchangeLayer()">
            <span
              class="icon"
              style="background-size: auto 0.53rem"
              :style="{
                'background-image': `url(${require('@/assets/images/user/my/5.png')})`,
              }"
            ></span>
            <div class="text">藏品兑换</div>
          </div>
          <div class="item" @click="goPage('/user/collection')">
            <span
              class="icon"
              style="background-size: auto 0.5rem"
              :style="{
                'background-image': `url(${require('@/assets/images/user/my/2.png')})`,
              }"
            ></span>
            <div class="text">收藏记录</div>
          </div>
          <div class="item" @click="goPage('/user/achievement')">
            <span
              class="icon"
              style="background-size: auto 0.51rem"
              :style="{
                'background-image': `url(${require('@/assets/images/user/my/3.png')})`,
              }"
            ></span>
            <div class="text">我的成就</div>
          </div>
          <div class="item" @click="goPage('/user/set')">
            <span
              class="icon"
              style="background-size: auto 0.48rem"
              :style="{
                'background-image': `url(${require('@/assets/images/user/my/4.png')})`,
              }"
            ></span>
            <div class="text">设置</div>
          </div>
        </div>
      </div>

      <div class="user-body">
        <van-sticky>
          <div class="user-title">
            <div class="tit">我的藏品：</div>
            <div class="tool-right">

              <!-- <div class="screen-option">
                <van-dropdown-menu>
                  <van-dropdown-item v-model="value1" :options="option1" />
                </van-dropdown-menu>
              </div> -->
              
              <div class="screen-menu"> 
                <span @click="goodsTimeSortBtn()" :class="goodsTimeSort === 1?'active':''"><div class="van-ellipsis">按时间排序</div></span>
              </div>

              <!-- <div class="view-wrap">
                <span
                  class="ui-icon"
                  :class="goodsWrap === 1 ? 'ui-icon-one' : 'ui-icon-two'"
                  @click="goodsWrapBtn()"
                ></span>
              </div> -->

            </div>
          </div>
        </van-sticky>

      

        <div class="goods-list" v-if="goodList.length > 0">

          <div class="goods-list-wrap">
            <div
              class="item"
              :class="goodsWrap === 1 ? '' : 'goods-wrap-2'"
              v-for="(item, index) in goodList"
              :key="index"
              @click="goPage('/user/treasure/details?id=' + item.id)"
            >
              <div class="item-goods-box">
                <div class="item-img">
                  <div
                    class="preview-img"
                    :style="{ backgroundImage: 'url(' + item.products[0].area.avatarimg + ')' }"
                  ></div>

                  <div class="item-time">{{ item.products[0].nftArt.getToDate | shiftTime }}</div>

                </div>
                <div class="item-info">

                  <div class="info-fl">
                    <div class="title">{{ item.products[0].nftArt.artName }}</div>
                    <div class="author">{{ item.products[0].nftArt.auther }}</div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="empty" v-else>
          <div class="text">暂无藏品</div>
          <div class="empty-icon"></div>
        </div>
      </div>

      <van-popup class="exchange-layer" :close-on-click-overlay='false' v-model="exchangeLayerShow1">
        <div class="exchange-dialog">
          <div class="exchange-dialog-header">
            请输入藏品兑换码
            <span class="exchange-dialog-close" @click="exchangeLayerShow1 = false"><img :src="require('@/assets/images/common/layer-close.png')" alt=""></span>
          </div>
          <div class="exchange-dialog-content">
            <div class="dialog-form">
              <div class="form-input">              
                <el-input
                    type="text"
                    v-model="redemptionCode"
                    placeholder=""
                    class="form-input"
                  ></el-input>
              </div>
              <div class="form-btn">
                <el-button class="exchange-btn" type="primary" @click="verifyCodeBtn()" :loading="isExchangeBtn1">确 定</el-button>
              </div>
            </div>
            

          </div>
        </div>
      </van-popup>

      <van-popup class="exchange-layer" :close-on-click-overlay='false' v-model="exchangeLayerShow2">
        <div class="exchange-dialog dialog2">
          <div class="exchange-dialog-header">
            请选择您的省份
            <span class="exchange-dialog-close" @click="exchangeLayerShow2 = false"><img :src="require('@/assets/images/common/layer-close.png')" alt=""></span>
          </div>
          
          <div class="exchange-dialog-content">
            <div class="dialog-form">
              <div class="dialog-select">                
                <div class="select-input" @click="citySelectShow = !citySelectShow">{{cityValue?cityValue:"请选择您的旗帜归属地"}}</div>
                <div class="select-hidden" v-show="citySelectShow">
                  <div class="item" :class="cityObj.id===parseInt(item.id)?'active':''" @click="citySelect(item.id,item.area)" v-for="(item,index) in cityList" :key="index">{{ item.area }}</div>
                </div>
              </div>
              <div class="dialog-tips">注意：请慎重选择一经确定无法更改</div>              
              <div class="form-btn">
                <el-button class="exchange-btn" type="primary" @click="createdBtn()" :loading="isExchangeBtn2">确 定</el-button>
              </div>
            </div>
          </div>

        </div>
      </van-popup>

      <van-popup class="lucky-layer" :close-on-click-overlay='false' v-model="exchangeLayerShow3">
        <div class="lucky-dialog">
          <div class="lucky-header"><img :src="require('@/assets/images/common/lucky-1.png')" alt=""></div>
          <div class="lucky-body">
            <div class="img-bg">
               <div class="img-box">
                <div class="img"><img :src="luckyInfo.imgUrl" alt="" /></div>
              </div>
            </div>
            <div class="lucky-text">{{ luckyInfo.content }}</div>
          </div>
          <div class="lucky-footer">
              <el-button class="exchange-btn" @click="luckyBtn" type="primary" >确 定</el-button>
          </div>
        </div>
      </van-popup>




    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
// import IScroll from '../../../assets/js/libs/iscroll';
import { Sticky, Toast, Popup, Dialog, DropdownMenu, DropdownItem } from "vant";


Vue.use(Sticky);
Vue.use(Popup );
Vue.use(Dialog );

Vue.use(DropdownMenu);
Vue.use(DropdownItem);

import { Input, Select, Option, OptionGroup,Button } from "element-ui";

Vue.use(Input);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);

Toast.setDefaultOptions({ duration: 1000 });


export default {
  name: "ucenter",
  data() {
    return {

      scan: this.$route.query.scan ? this.$route.query.scan : "",
      value1: 0,
      option1: [
        { text: '按时间排序', value: 0 },
        { text: '按类型排序', value: 1 },
      ],
      goodsWrap: 2,
      
      redemptionCode:'',
      exchangeLayerShow1:false,
      isExchangeBtn1:false,
      isExchangeBtn2:false,

      cityValue:'',
      cityObj:{
        id:-1,
        area:"",
      },
      citySelectShow:false,
      exchangeLayerShow2:false,

      cityList:[],

      
      exchangeLayerShow3:false,
      luckyInfo:{
        imgUrl:"",
        content:"",
      }

    };
  },

  created() {
    let that = this;
    if (!this.isLogin) {      
      if(Number(this.scan) === 1){
        this.$router.push("/login");
      }
      return false;
    }    


    this.getUserInfo({
      success: (res) => {
        // console.log(res)
        if(res.status === 1){
          that.getGoodsList();
        } else {
          Toast(res.message);
        }
      },
    });

  },

  methods: {
    ...mapActions({
      getUserInfo: "user/getUserInfo",
      setGoodsVerifyCode: "user/setGoodsVerifyCode",
      setGoodsCreateOrder: "user/setGoodsCreateOrder",
      getGoodsOrderList: "user/getGoodsOrderList",
      getGoodsOrderSort: "user/getGoodsOrderSort",
      // getGoods:"index/getGoods"
    }),

    goPage(url) {
      if (this.isLogin) {
        if(url === '/user/order') {
          Toast('暂未开放，敬请期待');
          return false;
        }        
        if(url === '/user/achievement') {
          Toast('暂未开放，敬请期待');
          return false;
        }        
        this.$router.push(url);
      } else {
        this.$router.push("/login");
      }
      // /user/order



    },

    scrollPreventDefault(e) {
      e.preventDefault();
    },


    goodsWrapBtn() {
      let index = this.goodsWrap;
      if (index === 1) {
        this.goodsWrap = 2;
      } else {
        this.goodsWrap = 1;
      }

      // this.$nextTick(()=>{
      //     this.myScroll.scrollTo(0,0,0,IScroll.utils.ease.quadratic);
      //     this.myScroll.refresh();
      // })
    },

    exchangeLayer(){

      if (!this.isLogin) {
        this.$router.push("/login");
        return false;
      }
      // if(Number(this.userInfo.account.is_nickname) !== 0){
      //   Toast('昵称还未通过审核，不可兑换')
      //   return false;
      // }
      this.exchangeLayerShow1 = !this.exchangeLayerShow1;
    },
    
    getGoodsList(){

      let goodsTimeSort = this.goodsTimeSort;
      this.getGoodsOrderList({
        goodsTimeSort:goodsTimeSort,
        success: (res) => {
          console.log(res)
          if (res.status !== 1) {
            Toast(res.message);
          }
        },
      });
    },

    
    goodsTimeSortBtn(){
      let goodsTimeSort;
      if(this.goodsTimeSort === 1){
        goodsTimeSort = 0;
      } else {
        goodsTimeSort = 1;
      }
      this.getGoodsOrderSort({
        goodsTimeSort:goodsTimeSort,
        success: (res) => {
          // console.log(res)
        },
      });
    },

    verifyCodeBtn(){
      let that = this;

      if (!that.isLogin) {
        that.$router.push("/login");
        return false;
      }

      let code = that.redemptionCode;
      if(!code.trim()){
        Toast("请输入藏品兑换码");
        return;
      }
      that.isExchangeBtn1 = true;   
      
      
      that.setGoodsVerifyCode({
        code,
        success: (res) => {
          that.isExchangeBtn1 = false;
          console.log(res)
          if (res.status == 1) {

            // Toast();
            that.exchangeLayerShow1 = false;
            that.exchangeLayerShow2 = true;
            
            let area = res.data.area;
            that.cityList = area;


          } else {
            Toast(res.message);
          }

        },
      });



    },
    citySelect(id,area) {
      // this.cityValue = val;

      this.cityObj.id = parseInt(id);
      this.cityObj.area = area;

      // this.citySelectShow = false;



    },

    createdBtn() {
      let that = this;
      let province = that.cityObj.area;
      let areaid = parseInt(that.cityObj.id);

      let code = that.redemptionCode;
      if(!province.trim()){
        Toast("请选择旗帜归属地");
        return;
      }

      that.isExchangeBtn2 = true;
      that.setGoodsCreateOrder({
        province,
        areaid,
        code,
        success: (res) => {
          that.isExchangeBtn2 = false;
          console.log(res)
          
          if (res.status == 1) {
            that.exchangeLayerShow2 = false;
            that.exchangeLayerShow3 = true;

            let imgUrl = res.data.area.avatarimg;
            let artName = res.data.insertArt.artName;
            
            that.luckyInfo.imgUrl = imgUrl;
            that.luckyInfo.content = artName;

            that.redemptionCode = '';
            that.cityValue = '';
            that.cityObj = {
              id:-1,
              area:"",
            };
            
            that.getGoodsList();

            
          } else {
            
            Toast(res.message);

          }

        },
      });

    },

    luckyBtn(){

      let that = this;
      that.exchangeLayerShow3 = false;

      setTimeout(function(){
        that.redemptionCode = '';
        that.cityValue = '';
        that.cityObj = {
          id:-1,
          area:"",
        };
        that.luckyInfo.imgUrl = '';
        that.luckyInfo.content = '';
      },800)

    },

    
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      userInfo: (state) => state.user.userInfo,
      guid: (state) => state.user.guid,
      security: (state) => state.user.security,

      goodList:(state)=>state.user.goodList,
      goodsTimeSort:(state)=>state.user.goodsTimeSort,

    }),
  },

  // mounted(){
  //     this.$refs['scroll-classify'].addEventListener("touchmove",this.scrollPreventDefault);
  //     this.myScroll=new IScroll(this.$refs['scroll-classify'], {
  //         scrollX : false,
  //         scrollY : true,
  //         preventDefault : false
  //     });
  // },
  // beforeDestroy(){
  //     this.$refs['scroll-classify'].removeEventListener("touchmove",this.scrollPreventDefault);
  // }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/goods/goodList.scss";

.lucky-layer {
  background: none;
  border-radius:0;
  overflow-y: visible;
}

.exchange-layer {
  border-radius: 0.1rem;
  overflow: hidden;
}
.exchange-btn {
  color: #fff;
  border-radius: 0.42rem;
  font-size: 0.3rem;
  width: 100%;
  background: linear-gradient(90deg, #f67879, #d81f1d);
  cursor: pointer;
  padding: 0.22rem 0;
  border: 0;
  &:disabled {
    background: #9e9e9e;
  }
}
.exchange-dialog {
  
  width: 6.4rem;
  overflow: hidden;
  font-size: 16px;
  // background-color: #fff;


  &.dialog2 {

    .exchange-dialog-header {
      background: linear-gradient(90deg, #d4d4d4, #787878);
    }

    .exchange-dialog-content {
      background: url("~@/assets/images/common/layer-footerbg.png") no-repeat left bottom;
      background-size: 100% auto;
    }

  }
  .exchange-dialog-header {
    font-weight: 500;
    text-align: center;
    background: #d7d7d7;
    line-height: 1rem;
    font-size: .4rem;
    color: #212121;
    position: relative;
  }
  .exchange-dialog-close {
    position: absolute;
    right: 0.3rem;
    top:50%;
    transform: translateY(-50%);
    img {
      width: 0.42rem;
      height: 0.42rem;
    }
  }
  .dialog-form {
    padding: 0.75rem 0.8rem 0.3rem;

    .form-input {
      
      ::v-deep .el-input__inner {
        
        background: #a1a1a1;
        text-align: center;
        color: #ffffff;
        box-shadow:1px 1px 1px #000000 inset;
        &::-webkit-input-placeholder,&::-moz-placeholder ,&::placeholder,&:-ms-input-placeholder {
          color: #ffffff;
        }

        height: 0.75rem;
        line-height: 0.75rem;
        font-size: 0.36rem;
        border-radius: 0.1rem;
        

      }
    }
    .form-btn {
      text-align: center;
      padding-top: 0.7rem;
      .exchange-btn {
        width: 2.4rem;
      }
    }
    .dialog-tips {
      text-align: center;
      font-size: .2rem;
      // color: #474646;
      color: #ff0000;
      padding: .55rem 0 0;
      &+div {
        padding-top: .2rem;
      }
    }

  }
  
  .dialog-select {
    // padding: 0.75rem 0.8rem 0.3rem;
    .select-input {
      text-align: left;
      color: #474646;
      background: url(../../../assets/images/common/layer-select-bg.png)no-repeat center;
      background-size: 100% 100%;
      height: 0.52rem;
      line-height: 0.52rem;
      font-size: 0.3rem;
      padding-left: 0.5rem;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        right: .15rem;
        width: .41rem;
        height: .27rem;
        background: url(../../../assets/images/common/layer-xiala.png)no-repeat left top;
        background-size: 100% 100%;
        top: 50%;
        margin-top: -.135rem;
      } 
    }
    .select-hidden {
      background: #bebebe;
      padding: 0.2rem 0 0 0.2rem;
      overflow: hidden;
      width: 96%;
      margin: 0 auto;
      box-sizing: border-box;
      min-height: 1.9rem;
      .item {
        float: left;
        background: #d8d8d8;
        font-size: .24rem;
        color: #616161;
        text-align: center;
        margin-right: 0.2rem;
        margin-bottom: 0.2rem;
        padding: 0 0.1rem;

        &.active {
          background: #ffffff;
          color: #000000;
        }
      }

    }


  }

}

.lucky-dialog {
  width: 4.97rem;
  text-align: center;
  position: relative;
  .lucky-header {
    text-align: center;
    position: absolute;
    left: 0;
    width: 100%;
    top: -0.4rem;
    img {
      width: 2.6rem;
    }
  }
  .lucky-body {
    background: url('~@/assets/images/common/lucky-2.png')no-repeat left top;
    background-size: 100% auto;
    height: 5.8rem;
    box-sizing: border-box;
    padding: 0.5rem 0.6rem;

    .img-bg {
      background: url('~@/assets/images/common/lucky-3.png')no-repeat left top;
      background-size: 100% 100%;
      width: 2.85rem;
      height: 2.88rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .img-box {
      
      width: 1.85rem;
      height: 1.85rem;
      box-sizing: border-box;
      border-radius: 0.09rem;
      background-color: rgba($color: #ffdc96, $alpha: .8);
      box-shadow: 0.726px 2.911px 1px 0px rgba(0, 0, 0, 0.55);
      padding: 0.07rem;
      box-sizing: border-box;
      margin: 0 auto;

      .img {
        width: 1.71rem;
        height: 1.71rem;
        background: #000000;
      }
      img {
        width: 100%;
        height: 100%;
      }
      
    }

    .lucky-text {
      text-align: center;
      font-size: .22rem;
      color: #fff2d7;
      line-height: 1.8;
    }
  }

  .lucky-footer {
    margin-top: .5rem;
    .exchange-btn {
      width: 2.4rem;
    }
  }


}



.page {
  width: 100%;
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  min-height: 100vh;
  background: #c7c7c5;
}
.user-header {
  padding: 0.55rem 0.55rem 0.7rem;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  .user-info {
    display: flex;
    align-items: center;
    
    .img {
      width: 1.34rem;
      height: 1.34rem;
      box-sizing: border-box;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #2b2b2a;
      margin-right: 0.23rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      line-height: 1;
      flex: 1;
      .name {
        font-size: 0.45rem;
        color: #2b2b2a;
        width: 4rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .phone {
        font-size: 0.2rem;
        color: #3c3c3c;
        margin-top: 0.2rem;
        // padding-left: 0.08rem;
        white-space: nowrap;

      }

    }
  }
  .user-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.6rem;
    padding: 0 0.25rem;
    text-align: center;
    .icon {
      display: block;
      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
      height: 0.53rem;
      width: 0.53rem;
      margin: 0 auto;
    }
    .text {
      font-size: 0.22rem;
      color: #2b2b2a;
      margin-top: 0.15rem;
    }

    .item:active {
      opacity: .8;
    }
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 0.5rem;
    border-radius: 0.3rem 0.3rem 0 0;
    background: #c8c8c6;
    margin-top: -0.3rem;
  }
}
.user-body {
  padding: 0 0 0.45rem;
  .user-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.15rem 0.45rem;
    background: #c7c7c5;
    .tit {
      font-size: 0.36rem;
      color: #444444;
    }

    .tool-right {
      display: flex;
      align-items: center;
      .view-wrap {
        font-size: 0;
        .ui-icon {
          display: inline-block;
          width: 0.4rem;
          height: 0.4rem;
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: contain;
        }
        .ui-icon-one {
          background-image: url("~@/assets/images/home/goods/icon-one.png");
        }
        .ui-icon-two {
          background-image: url("~@/assets/images/home/goods/icon-two.png");
        }
      }

      .screen-menu {
        span {
          position: relative;
          display: block;
          color: #ffffff;
          font-size: 0.24rem;
          background: url("~@/assets/images/home/goods/icon-2.png") no-repeat center;
          background-size: 100% 100%;
          padding: 0 14px 0 8px;
          height: 0.5rem;
          line-height: 0.5rem;
          &.active {

            &::after {
              margin-top: -1px;
              -webkit-transform: rotate(135deg);
              transform: rotate(135deg);

            }
          }

          &::after {
            position: absolute;
            top: 50%;
            margin-top: -5px;
            border: 3px solid;
            border-color: transparent transparent #dcdee0 #dcdee0;
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
            opacity: .8;
            content: '';

            right: 4px;
            border-color: transparent transparent #ffffff #ffffff;

          }
        }
      }

      .screen-option {
        // margin-right: 0.5rem;
        // background: url("~@/assets/images/home/goods/icon-2.png") no-repeat center;
        // background-size: 100% 100%;
        // padding: 0 10px 0 0;
        
        ::v-deep .van-dropdown-menu__bar {
          background: none;
          
          
          .van-dropdown-menu__title {
            color: #ffffff;
            font-size: 0.24rem;
            background: url("~@/assets/images/home/goods/icon-2.png") no-repeat center;
            background-size: 100% 100%;
            padding: 0 14px 0 8px;
            height: 0.5rem;
            line-height: 0.5rem;
          }
          .van-dropdown-menu__title::after {
            right: 4px;
            border-color: transparent transparent #ffffff #ffffff;
          }
        }
      }
      
    }
  }
  .goods-list {
    padding: 0.1rem 0.15rem;
  }
}
.empty {
  text-align: center;
  font-size: 0.36rem;
  color: #444444;
  margin-top: 2rem;
  .empty-icon {
    width: 2.37rem;
    height: 1.56rem;
    background: url("~@/assets/images/common/ic-empty.png") no-repeat
      center;
    background-size: contain;
    display: inline-block;
    margin: 0.3rem;
  }
}
</style>